import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import ButtonPattern from '@mlb/react-patterns/components/Button/button.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    padding-top: 12px;
    padding-bottom: 24px;
    box-shadow: 0 0 7px 0 rgba(136, 136, 136, 0.49);
    background-color: ${COLORS.mlbGrey7};
`;

const ApplyButton = styled(ButtonPattern)`
    width: 174px;
`;

const Footer = ({
    applyButtonRef,
    onApplyButtonClick,
    dictionary,
}) => {

    return (
        <Wrapper>
            <ApplyButton
                label={dictionary?.apply_sort || 'Apply Sort'}
                size={'md'}
                styleName={'link-blue'}
                handlers={{
                    onClick: () => {

                        onApplyButtonClick();

                    },
                }}
                ref={applyButtonRef}
            />
        </Wrapper>
    );

};

Footer.propTypes = {
    applyButtonRef: PropTypes.object.isRequired,
    onApplyButtonClick: PropTypes.func,
    dictionary: PropTypes.object,
};

Footer.defaultProps = {
    dictionary: {},
    onApplyButtonClick: _noop,
};

export default Footer;
